import { cn } from '../../lib/utils'
import {
  formFieldBaseClass,
  formFieldFocusClass,
} from '../ui/foundation/formFieldStyles'

export const secondaryPageTitleClass =
  'font-sans text-[20px] font-semibold leading-[1.3] text-ink-700'

export const secondaryCardClass =
  'rounded-lg border border-[rgba(36,34,30,0.06)] bg-white shadow-none'

export const secondaryInputClass = cn(
  'w-full px-4',
  formFieldBaseClass,
  formFieldFocusClass
)

export const secondaryTextInputClass = cn(secondaryInputClass, 'h-11')

export const secondarySelectClass = cn(
  secondaryTextInputClass,
  'appearance-none pr-11'
)

export const secondaryTextareaClass = cn(
  secondaryInputClass,
  'min-h-[120px] py-3 resize-none'
)

export const secondaryLabelClass =
  'mb-1.5 block font-sans text-fs-400 font-medium text-ink-700'

export const secondaryHelperTextClass =
  'mt-1.5 font-sans text-[13px] font-normal text-ink-400'

export const kickerLabelClass =
  'font-sans text-[11px] font-medium uppercase tracking-[0.16em] text-ink-400'

export const inlineLinkClass =
  'text-primary-400 underline decoration-[rgba(36,34,30,0.25)] underline-offset-[3px] decoration-1 transition-colors duration-settle hover:decoration-[rgba(36,34,30,0.60)]'

export const quietLinkClass =
  'font-sans text-fs-300 font-medium text-primary-300 transition-colors duration-settle hover:text-primary-400'

export const legalPageTitleClass =
  'text-center font-serif text-fs-700 font-semibold tracking-tight text-ink-700'

export const legalSectionHeadingClass =
  'mb-4 font-serif text-fs-600 font-semibold tracking-tight text-ink-700'

export const legalSubheadingClass =
  'mt-6 mb-2 font-sans text-fs-400 font-medium text-ink-700'

export const legalBodyClass =
  'font-sans text-fs-400 font-normal leading-relaxed text-ink-500'

export const legalBulletListClass =
  'list-disc pl-6 space-y-2 font-sans text-fs-400 text-ink-500 marker:text-ink-400'
